import CustomCheckbox from '../../components/mazraeKit/customCheckbox';
import DateBottomSheet from '../../pages/farm/advertisementRegisteration/pages/optionalInfo/bottomsheetList/dateBottomSheet';
import DropBottomSheet from '../../pages/farm/advertisementRegisteration/pages/optionalInfo/objectComponents/dropBottomsheet';
import DropBottomSheetWithRadio from '../../pages/farm/advertisementRegisteration/pages/optionalInfo/objectComponents/dropBottomSheetWithRadio';
import MultiSelectDropBottomSheet from '../../pages/farm/advertisementRegisteration/pages/optionalInfo/objectComponents/multiSelectDropBottomSheet';
import OptionalSimpleInput from '../../pages/farm/advertisementRegisteration/pages/optionalInfo/objectComponents/optionalSimpleInput';
import {IDropBottomSheet} from '../../pages/farm/advertisementRegisteration/types';

export const compoentnsFromGenerator: Record<string, IDropBottomSheet> = {
  dropBottomSheet: {
    component: ({
      data,
      onChange,
      placeholder,
      name,
      value,
      generalTitle,
      generalDesc,
      subDesc,
      disabled,
    }) => (
      <DropBottomSheet
        name={name}
        placeholder={placeholder}
        onChange={e => onChange(name, e)}
        value={
          typeof value === 'object'
            ? (value?.title as string)
            : (value as string)
        }
        data={data || []}
        generalTitle={generalTitle}
        generalDesc={generalDesc}
        subDesc={subDesc}
        disabled={disabled}
      />
    ),
  },
  optionalSimpleInput: {
    component: ({onChange, label, name, placeholder}) => (
      <OptionalSimpleInput
        name={name}
        label={label}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          onChange(name, e.target.value);
        }}
        placeholder={placeholder}
      />
    ),
  },
  multiSelectDropBottomSheet: {
    component: ({data, onChange, name, placeholder}) => (
      <MultiSelectDropBottomSheet
        name={name}
        onChange={e => onChange(name, e)}
        placeholder={placeholder}
        data={data || []}
      />
    ),
  },
  dropBottomSheetWithRadio: {
    component: ({data, onChange, name, placeholder}) => (
      <DropBottomSheetWithRadio
        name={name}
        onChange={e => onChange(name, e)}
        placeholder={placeholder}
        data={data || []}
      />
    ),
  },
  dateBottomSheet: {
    component: ({
      data,
      onChange,
      name,
      placeholder,
      value,
      generalDesc,
      generalTitle,
      title,
      titleRequired,
    }) => (
      <DateBottomSheet
        name={name}
        onChange={e => {
          onChange(name, e);
        }}
        placeholder={placeholder}
        data={data || []}
        value={value as string}
        generalTitle={generalTitle}
        generalDesc={generalDesc}
        title={title}
        titleRequired={titleRequired}
      />
    ),
  },
  checkbox: {
    component: ({onChange, name, placeholder, value, title, checked}) => {
      return (
        <CustomCheckbox
          name={name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            onChange(name, {
              title: title,
              value: e.target.checked ? 'true' : 'false',
            });
          }}
          placeholder={placeholder}
          value={value as string}
          title={title}
          checked={checked}
          titleClass="font-[500]"
        />
      );
    },
  },
};
